import type { MessageKey } from '@/modules/localizations';
import { ErrorCode } from '@/services/utilities/isApiError';

export const oAuthErrorMessages = {
    [ErrorCode.FIRST_LOGIN_BY_ADMIN]: 'error.auth.first-login',
    [ErrorCode.MISSING_CLIENT_SECRET]: 'error.auth.client-secret',
    [ErrorCode.ACCOUNT_NOT_IN_WORKSPACE]: 'error.auth.account-not-in-workspace',
    [ErrorCode.USER_NOT_A_MEMBER_OF_A_WORKSPACE]: 'error.auth.userNotAMemberOfAWorkspace',
} satisfies Partial<Record<ErrorCode, MessageKey>>;
